import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageCode, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { Language, LanguageFileName } from 'src/app/shared/Models/WidgetSettingsModels';
import { LocalizeService } from 'src/app/shared/services/localize.service';
import moment from 'moment';
import { LayoutService } from 'src/app/layout/layout.service';
import { DEFAULT_LANGUAGE_ID } from 'src/app/shared/constants/commonenums';

@Component({
  selector: 'app-v2-header',
  templateUrl: './v2-header.component.html',
  styleUrls: ['./v2-header.component.scss']
})
export class V2HeaderComponent implements OnInit {
  @ViewChild('cdTimer') cdTimer: any;

  showTimer: boolean;
  hideArrow = false;
  hideCart = false;
  initialLanguageChange = true;
  languageConfig:FieldConfig[];
  languageOptions=[];
  IsMultiLanguageSelectionEnabled: boolean;
  @Input() logoImg = '';
  restaurantId:number;
  showLanguageDropDown = true;

  constructor(
    public activityService: GuestService,
    private ts: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private localizeService: LocalizeService,
    private ls:LayoutService
    ) {
    this.activityService.restaurantMerchantCode = this.route.snapshot.params.merchantId;
 //   this.activityService.loadLanguageData(null);
    this.activityService.timer.subscribe(val => {
      if (val) {
        this.showTimer = true;
        this.cdTimer.start();
      } else {
        this.showTimer = false;
        this.cdTimer?.stop();
      }
    });

    this.activityService.hideBackNavigation.subscribe(val => {
      if (val) {
        this.hideArrow = true;
        this.activityService.showLanguageOption = true;
      } else {
        this.hideArrow = false;
        this.activityService.showLanguageOption = false;
      }
    });

    this.activityService.backNavigateURL.subscribe((val: any) => {
      if (val.URL) {
        if(val.URL === 'list' && this.activityService.operation === operationType.edit) { this.activityService.emptyCartData(); }
        this.activityService.navigateToUrl(val.URL);
      }
    });

    this.restaurantId = this.activityService.isDining ? this.activityService.selectedDining.RestaurantId
      : this.activityService.isNonDining ? this.activityService.selectedNonDining.RestaurantId : this.activityService.selectedActivities.RestaurantId;

    this.activityService.CartBookingList$.subscribe(data => {
      const CartList = sessionStorage.getItem('CartList_' + this.activityService.restaurantMerchantCode) ? JSON.parse(sessionStorage.getItem('CartList_' + this.activityService.restaurantMerchantCode)) : [];
      this.activityService.cartCount = CartList.length;
    });

    this.activityService.hideCart.subscribe(val => {
      if (val) {
        this.hideCart = true;
      } else {
        this.hideCart = false;
      }
    });
  }

  ngOnInit(): void {
    this.activityService.restaurantMerchantCode = this.route.snapshot.params.merchantId;
    this.activityService.getCartCount();
     this.setLanguageConfig();
  }
  


  setLanguageConfig(){
    this.generateLanguageOptions();
    this.activityService.checkLanguageAvailabilityOption();
    this.languageConfig = [
      {
        type: 'select',
        name: 'sortBy',
        placeholder: '',
        options: this.languageOptions || [],
        value: this.activityService.selectedLanguageId ? this.activityService.selectedLanguageId : DEFAULT_LANGUAGE_ID,
        showErrorText: true,
        isTranslate: true,
        appearance: false,
        cellClick: this.setDefaultLanguage.bind(this),
        class: 'header__language',
        isFormArray: false,
        appearanceOutline: true,
        label: this.ts.instant('language')
      }
  ];
  const url = new URL(window.location.href);
  let language = this.route.snapshot.params['language'] || url.searchParams.get('language');
  if(language){
    this.activityService.selectedLanguageId = Number(LanguageFileName[language]);
    this.languageConfig[0].value = this.activityService.selectedLanguageId;
    this.languageConfig = [...this.languageConfig];
  }
  if(!language){
 
    language = this.route.snapshot.queryParams['language'];
    language =  language?.toLowerCase();
    this.languageConfig[0].value = language ? LanguageFileName[language] : sessionStorage.getItem('languageId') ? Number(sessionStorage.getItem('languageId')): DEFAULT_LANGUAGE_ID ;
    this.languageConfig = [...this.languageConfig];
    this.setLanguage({value: sessionStorage.getItem('languageId') ? sessionStorage.getItem('languageId') : DEFAULT_LANGUAGE_ID}, language)
  }
  }

  setDefaultLanguage(event){
    if(this.initialLanguageChange){
      sessionStorage.setItem('languageId',event.value);
      this.activityService.selectedLanguageId = Number(event.value);
      this.initialLanguageChange = false;
      this.activityService.loadLanguageData(true);

    }
    this.setLanguage(event)
  }

  navigate(){
    if(this.activityService.mealWithConfig){
    }
    else{
      this.activityService.navigateToHome();
    }
  }

  onTimerComplete(event) {
    if (this.activityService.currentNavURL === 'order-summary') {
      this.showTimer = false;
      this.activityService.navigateToUrl('list');
    }
  }

  cartProceed() {
    if (this.activityService.getCartCount() === 0) {
      this.activityService.
      openSnackBar(this.ts.instant('addItemstoCarttoProceed'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
      return false;
    }
    this.activityService.lockMultiPropertySessionsfn(this.activityService.restaurantMerchantCode, true);
  }
  generateLanguageOptions(){
     this.activityService.widgetConfigurations.subscribe((data : any) => {
      this.IsMultiLanguageSelectionEnabled = data.IsMultiLanguageSelectionEnabled;

      if(data.Languages?.length)
      this.activityService.availableLanguages = data.Languages;
        this.languageOptions  = data.Languages.map(language =>  { return { id: language.Id , value: language.DisplayName}});
      this.languageConfig[0].options = this.languageOptions;
      this.languageConfig[0].value = this.activityService.selectedLanguageId ? this.activityService.selectedLanguageId : this.languageOptions[0].id;
    })
  }


  /* setting language on change of drop down */
  setLanguage(event ,language?) {

   if(language && this.activityService.availableLanguages){
    event.value = this.activityService.availableLanguages.find(lng => lng.Name.toLowerCase() == language)?.Id || DEFAULT_LANGUAGE_ID
  }

    let selectedLanguage=LanguageFileName[event.value];
    sessionStorage.setItem('languageId', event.value)
    sessionStorage.setItem('languageCode', LanguageCode[selectedLanguage]);
    this.activityService.selectedLanguage = selectedLanguage;
    this.activityService.languageFileChanges.next(true);
    this.activityService.selectedLanguageId = event.value;
    this.localizeService.setLanguage(selectedLanguage, 'universal' , sessionStorage.getItem('restaurantMerchantCode'));
   
    
  }

  setLanguageConstant(lngConstants){
    this.activityService.languageConstants =[];
    lngConstants.forEach(lngConst => {
      this.activityService.languageConstants[lngConst.LanguageKey] = JSON.parse(lngConst.LanguageValue);
    })
    
  }

}
